// Referral link (#1) + public "What's New" feed (#23).
import { api } from "./client";

export const getMyReferrals = () => api.get("/referrals");
export const getUpdates = () => api.get("/updates");

// Coupon preview at checkout (company user).
export const validateCoupon = (plan_id, coupon_code) => api.post("/billing/validate-coupon", { plan_id, coupon_code });
